import IService from "@api/iService";
import { CustomQuery, IQueryResult } from "@interfaces/query";
import { CustomQueryModel } from "@models/query/queries";

export default class QueryService extends IService {

    async executeCustomQuery(query: CustomQueryModel) {
        return await this.postApi<IQueryResult>('/api/query/', query);
    }
    
    async fetchQueries() {
        return await this.getApi<CustomQuery[]>('/api/query/');
    }
}